<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

@import url("https://fonts.googleapis.com/css?family=Poppins");

// Set your colors
$primary: #0098da;
$primary-invert: findColorInvert($primary);
$twitter: #4099ff;
$twitter-invert: findColorInvert($twitter);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  ),
  "twitter": (
    $twitter,
    $twitter-invert
  )
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles. Leave them in this position
@import "~bulma";
@import "~buefy/src/scss/buefy";

html,
body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-size: 14px;
}

#app {
  width: 100%;
  height: 100%;
  min-height: 100%;
  font-family: "Poppins", helvetica;
}
//custom styles
.column {
  padding: 0.5rem !important;
}

.input {
  background-color: white !important;
  box-shadow: none !important;
}

.input {
  height: 2.65em !important;
}
.input[type = "text"] {
  font-size: inherit !important;
}

.label {
  color: darkslategrey !important;
  text-transform: uppercase;
  font-weight: lighter !important;
  font-size: 12px !important;
}

.steps .step-item .step-details .step-title {
  font-size: 1em !important;
}

.has-letter-spacing-3 {
  letter-spacing: 3px !important;
}

.has-border-bottom {
  border-bottom: 1px dashed rgb(218, 218, 218) !important;
}

.card {
  box-shadow: none !important;
}

.has-max-width-1500 {
  max-width: 1500px !important;
}

.has-margin-0-auto {
  margin: 0 auto !important;
}

.table td,
.table th {
  vertical-align: middle;
  font-size: .8em;
}

.b-table .table th {
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.8em;
}

.is-black {
  color: black;
}

.is-search {
  height: 2.65em;
  min-width: 150px;
  background-color: lightblue;
}

.is-primary {
  height: 2.65em;
}

.has-width-100-percent {
  width: 100%;
}

.button {
  height: 2.65em;
  min-width: 100px;
}

.has-border-right {
  border-right: 1px solid lightgrey;
}

.has-border-bottom-solid {
  border-bottom: 1px solid rgba(256, 256, 256, 0.1);
}

.has-flex-one {
  flex: 1;
}

.has-background-green {
  background: green !important;
}

.has-background-yellow {
  background: yellow !important;
  color: black !important;
}

.has-background-red {
  background: rgb(255, 94, 0) !important;
}

.is-white {
  color: white;
}

.has-background-black {
  background: black !important;
}

.has-text-align-center {
  text-align: center;
}
.action-item {
  display: flex;
  align-items: center;
}

.action-text{
  padding-left: .6em;
  font-weight: bold;
  font-size: 0.7em;
}

.has-width-500 {
  width: 500px;
}

.has-flex-grow-1 {
  flex-grow: 1;
}

button span {
  padding-left: 0 !important;
}
body {
  font-size: 15px;
}

.has-default-logo--style {
  height: 55px;
  padding: 5px;
  margin-left: 40px;
  border-radius: 15px;
}
@media screen and (max-width: 1300px){
  .table{
    font-size: 13px;
  }
}

// This block of styles allows modals with tall content to scroll
html,
body,
#app,
#app > div,
.animation-content,
.animation-content > div,
.modal-card,
.modal-card-body {
  overflow: auto;
}
</style>

<script>
import { resetLocalStorage } from "@/store/index";
import { mapState, mapMutations as mapRootMutations } from "vuex";

import { createNamespacedHelpers } from "vuex";
const { mapMutations } = createNamespacedHelpers("shippers");

import {
  ROOT_MUTATION_TYPES,
  SHIPPER_MUTATION_TYPES
} from "@/store/mutation-types";

export default {
  name: "App",

  methods: {
    ...mapRootMutations({
      resetRootState: ROOT_MUTATION_TYPES.RESET_STATE
    }),

    ...mapMutations({
      resetShipperState: SHIPPER_MUTATION_TYPES.RESET_STATE
    }),

    logout() {
      resetLocalStorage();
      this.resetRootState();
      this.resetShipperState();

      this.$router.push({ name: "login", params: { appIsIdle: true } });
    }
  },

  /**
   * Hook fn called when the user has been idle for 5 minutes (injected by the vue-idle plugin)
   */
  onIdle() {
    if (this.$route.meta.requiresAuth) {
      this.logout();
    }
  },

  /**
   * Hook fn called when the user has becomes active after being idle (injected by the vue-idle plugin)
   */
  onActive() {}
};
</script>
